/* eslint-disable @typescript-eslint/no-explicit-any */
const SvgTypeH4 = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="type-h4_svg__bi type-h4_svg__bi-type-h1"
    {...props}
  >
    <path d="M7.637 13V3.669H6.379V7.62H1.758V3.67H.5V13h1.258V8.728h4.62V13Zm5.337.2v-2.328H9.108V9.828l3.441-6.35h1.632v6.141H15.5v1.253h-1.319V13.2Zm-2.615-3.581h2.615V6.7L13 4.689l-.872 1.7z" />
  </svg>
);
export default SvgTypeH4;
